// extracted by mini-css-extract-plugin
export default {"homeWrapper":"Home_homeWrapper__DKDBH","loader":"Home_loader__X5Z+J","rotation":"Home_rotation__OVPgB","mainMenu":"Home_mainMenu__BlYIG"};